import { cn } from '#app/utils/misc'

export interface StatementProps {
	text: string
	align?: 'left' | 'center'
}

export function Statement({
	text = 'Spiral writes with natural rhythm, concrete details, and clear language—good taste built in from the start.',
	align = 'center',
}: StatementProps) {
	return (
		<section className="bg-muted/30 w-full py-24 md:py-32">
			<div className="container px-4 md:px-6">
				<div
					className={cn(
						'mx-auto max-w-4xl',
						align === 'center' ? 'text-center' : 'text-left',
					)}
				>
					<h2 className="text-title-1">{text}</h2>
				</div>
			</div>
		</section>
	)
}
